export default __webpack_public_path__ + "static/media/manguezais-cover.f8f6d7ae.png";